module.exports = __webpack_public_path__ + "366eb2a81ddec837a64b07636c787e23.MP3";